import React from 'react';
// ui
import { Typography } from 'rmwc/Typography';

const Acknowledgements = () => {
    return (
        <div>
            <div className="app--section">

                <Typography use={'headline4'} tag={'h2'} style={{ textAlign: 'center' }}>
                    Acknowledgements
                </Typography>
                <Typography use={'body1'}>
                    <p>
                        My sincere thanks for help with the research of Newspaper reports from the time,
                        individual
                        histories and photographs must go to:-
                    </p>
                    <p>
                        Cumbria County Council, Barrow Local Area Committee for grant funding.
                    </p>
                    <p>
                        Fiona Thomson, Nicola Parrington – for help with proof reading and printing.
                    </p>
                    <p>
                        Grateful thanks to the following surviving relatives for information, photographs etc:-
                    </p>
                    <ul>
                        <li>
                            Roger Bridge, Janet Morley and Barbara Brockbank (Thomas Varcoe)
                        </li>
                        <li>
                            Ian Werry (Harvey Simpson Werry)
                        </li>
                        <li>
                            Leslie Woodend (Reginald Woodend MM)
                        </li>
                        <li>
                            Marjorie Dearns (William Kitchen)
                        </li>
                        <li>
                            Miss Dorothy Round (John Round)
                        </li>
                        <li>
                            Mrs Staveley – Wray Nr. Lancaster
                        </li>
                        <li>
                            John Trenouth (William Trenouth)
                        </li>
                        <li>
                            Ray Dent (Thomas Lowther)
                        </li>
                        <li>
                            Ian Fell (Robert Lupton)
                        </li>
                    </ul>
                    <p>
                        Rod White and Staff at Barrow Library Archive for help with researching articles in
                        Barrow
                        News.
                    </p>
                    <p>
                        Gillian Blamire for help with research.
                    </p>
                    <p>
                        Angela Knowles for proof reading and help with bid for funding to Cumbria County
                        Council.
                    </p>
                    <p>
                        Andrew Shepherd and Wendy Maddox for help with proof reading.
                    </p>
                </Typography>
            </div>
        </div>
    )
};

export default Acknowledgements;


// WEBPACK FOOTER //
// ./src/app/components/Acknowledgements.js